import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Daily.css'; // Reutilizamos estilos
import slide1 from '../assets/trade1.avif';
import slide2 from '../assets/Daily2.avif';
import { Workflow, ChartPie } from 'lucide-react';

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

const TradeTrack = () => {
  const navigate = useNavigate();

  return (
    <motion.div 
      className="dashboard-container"
      initial={isMobile ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
      animate={isMobile ? { opacity: 1, y: 0 } : { opacity: 1, y: 0 }}
      exit={isMobile ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
      transition={isMobile ? { duration: 0 } : { duration: 0.5 }}
    >
      <div className="title-section">
        <h1 className="dailymenu">Trade - Marketing</h1>
        <div className="title-underline-daily"></div>
        <h1 className="subtitle-daily">Trade - Tracking </h1>
      </div>

      <div className="daily-menu-grid">
          {/* Card 1: Ventas Bultos */}
          <div className="daily-card" onClick={() => navigate('/tradeflow')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide1})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <Workflow size={28} color="white" />
              </div>
              <h3>Flujo de Solicitudes</h3>
              <p>Seguimiento de requerimientos de Trade.</p>
            </div>
          </div>

          {/* Card 2: Ventas USD */}
          <div className="daily-card" onClick={() => navigate('/kpitrade')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide2})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <ChartPie size={28} color="white" />
              </div>
              <h3>Kpi Trade</h3>
              <p>Indicadores para seguimiento de requerimientos de Trade.</p>
            </div>
          </div>
      </div>
    </motion.div>
  );
};

export default TradeTrack;